<template>
    <div class="historyBox">
        <p>共收听过{{ totalRow }}条声音</p>
        <ul>
            <li v-for="(item, index) in bookList" :key="index" @click="playAudio(item)" :title="item.name">
                <dl :class="bookInfo.id == item.book ? 'act' : ''">
                    <dt>
                        <img :src="item.cover" alt="">
                        <i></i>
                    </dt>
                    <dd>
                        <div>
                            <p>{{ item.name }}<span>{{ item.date }}</span></p>
                            <p>{{ item.author }}</p>
                            <div>
                                <div>
                                    <i></i>
                                    <p>{{ item.plays }}</p>
                                </div>
                                <div>
                                    <i></i>
                                    <p>{{ commin.fn.setAudioTime( item.duration ) }}</p>
                                </div>
                            </div>
                        </div>
                        <div @click.stop="delHistory(item.id)"></div>
                    </dd>
                </dl>
            </li>
        </ul>
        <pager :total-page="totalPage" :initPage="pageNum" @go-page="goPageNum" v-if="isShowPager" />
    </div>
</template>
<script>
import pager from '../pager.vue'
export default {
    components: {
        pager
    },
    data() {
        return {
            bookList: [
                // {
                //     "name": "伟成最帅",
                //     "name1": "伟成"
                // },
                // {
                //     "name": "伟成最帅",
                //     "name1": "伟成"
                // },
                // {
                //     "name": "伟成最帅",
                //     "name1": "伟成"
                // },
                // {
                //     "name": "伟成最帅",
                //     "name1": "伟成"
                // },
            ],
            totalRow: -1,
            totalPage: 1,
            pageNum: 1,
            isShowPager: false,
        }
    },
    computed: {
        bookInfo(){
            return this.$store.state.bookInfo;
        },
    },
    mounted() {
        let that = this;
        that.historyBooks();
    },
    methods: {
        historyBooks() {
            let that = this;
            let data = {
                page: that.pageNum,
                size: 5
            }
            that.allApi.historyList(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    if( resource.data.data.list.length > 0 ) {
                        that.bookList = resource.data.data.list;
                        that.totalRow = resource.data.data.total;
                        if( that.pageNum == 1 ) {
                            that.totalPage = resource.data.data.pages;
                            if( that.totalPage == 1 ) {
                                that.isShowPager = false;
                            }else{
                                that.isShowPager = true;
                            }
                        }
                    }else{
                        that.$router.push({
                            path: "noBook",
                            query: {
                                type: "history"
                            }
                        });
                    }                    
                }else if( resource.data.code == 401 ) {
                    that.$router.push({
                        path: "/"
                    });
                }
            })
        },
        goPageNum(obj) {
            let that = this;
            that.pageNum = obj.page;
            that.historyBooks();
        },
        bookDetail(item) {
            let that = this;
            let data = {
                book: item.book
            }
            that.allApi.bookDetail(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    that.$store.commit("setBookInfo", resource.data.data);
                    that.$store.commit("setCollectCode", resource.data.data.collect);
                    
                }else if( resource.data.code == 401 ) {
                    that.$router.push({
                        path: "/"
                    });
                }
            })
        },
        getChapters(item) {
            let that = this;
            let data = {
                book: item.book,
                history: true,
                page: 1,
                size: 10
            }

            that.allApi.chapterList(data).then((resource) => {
                // console.log(resource.data);
                if( resource.data.code == 200 ) {
                    that.$store.commit("setTotalPage", resource.data.data.page.pages);
                    let historyChapterIdx = parseInt( (resource.data.data.history.sort - 1) % 10 ) == 0 ? parseInt( (resource.data.data.history.sort - 1) / 10 ) : parseInt( (resource.data.data.history.sort - 1) % 10 );
                    console.log(resource.data.data.page.list[resource.data.data.history.sort-1])
                    that.$store.commit("setActChapter", resource.data.data.page.list[resource.data.data.history.sort-1]);
                    that.$store.commit("setActChapterIdx", historyChapterIdx);
                    that.$store.commit("setActChapterCurrentTime", resource.data.data.history.duration);
                    that.$store.commit("setChapters", resource.data.data.page.list);  
                    that.bookDetail(item);                  
                }
            })
        },
        playAudio(item) {
            let that = this;
            that.getChapters(item);
            
            that.addClickNum(item);
        },
        delHistory(id) {
            let that = this;
            let data = {
                id: id
            }
            that.allApi.deleteHistory(data).then((resource)=>{
                if( resource.data.code == 200 ) {
                    that.historyBooks();
                }
            })
        },
        addClickNum(item) {
            let that = this;
            let data = {
                book: item.book
            }
            that.allApi.bookClick(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .historyBox{
        overflow: hidden;
        padding-bottom: 30px;
        >p{
            font-size: 18px;
            @include secondary_color(#999);
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            line-height: 20px;
            margin: 0 34px 20px;
        }
        >ul{
            padding: 0 34px;
            >li{
                border-bottom: 1px solid #ccc;
                padding-bottom: 20px;
                margin-bottom: 20px;
                >dl{
                    display: flex;
                    cursor: pointer;
                    >dt{
                        background-position: center;
                        background-repeat: no-repeat;
                        background-image: url('../../assets/imgs/readerCenter/book_bg.png');
                        width: 126px;
                        height: 126px;
                        border-radius: 126px;
                        position: relative;
                        margin-right: 30px;
                        >img{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            width: 87px;
                            height: 87px;
                            border-radius: 87px;
                            background: #fff;
                        }
                        >i{
                            position: absolute;
                            width: 33px;
                            height: 33px;
                            background-position: center;
                            background-repeat: no-repeat;
                            background-image: url('../../assets/imgs/readerCenter/btn_stop.png');
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                    >dd{
                        width: 0%;
                        flex: 1;
                        padding: 10px 0;
                        display: flex;
                        align-items: center;
                        >div:first-child{
                            flex: 1;
                            >p:first-of-type{
                                overflow: hidden;
                                @include dominant_color(#1c1c1c);
                                font-size: 20px;
                                line-height: 26px;
                                >span{
                                    float: right;
                                    @include secondary_color(#999);
                                    font-size: 18px;
                                }
                            }
                            >p:last-of-type{
                                @include secondary_color(#999);
                                font-size: 18px;
                                margin-bottom: 25px;
                                line-height: 25px;
                            }
                            >div{
                                overflow: hidden;
                                >div{
                                    float: left;
                                    margin-right: 20px;
                                    overflow: hidden;
                                    line-height: 22px;
                                    >i{
                                        float: left;
                                        width: 22px;
                                        height: 22px;
                                        margin-right: 10px;
                                        background-position: center;
                                        background-repeat: no-repeat;
                                        background-image: url('../../assets/imgs/readerCenter/book_play_num.png');
                                    }
                                    >p{
                                        float: left;
                                        font-size: 14px;
                                        @include secondary_color(#999);
                                    }
                                    &:last-child{
                                        >i{
                                            background-image: url('../../assets/imgs/readerCenter/book_time.png');
                                        }
                                    }
                                }
                            }
                        }
                        >div:last-child{
                            width: 32px;
                            height: 32px;
                            background: url("../../assets/imgs/readerCenter/del.png") center no-repeat;
                        }
                    }
                    &.act{
                        >dt{
                            >i{
                                background-image: url('../../assets/imgs/readerCenter/btn_playing.png');
                            }
                        }
                    }
                }
            }
        }
    }
</style>
